import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";
import {convertPersianDateToUniversalDate} from "../../utils/TimeConvertor";


export class UnionService {

    constructor(token, snackbar, loading, fundId) {
        this.loading = loading;
        this.snackbar = snackbar;
        this.token = token;
        this.fundId = fundId;

        this.httpClient = new HttpClient()
    }

    getFundUnionInfo(pageSize) {
        const fundUnionInfo = this.httpClient.get(
            `fund-presentation/funds/${this.fundId}/union-financial-information`,
            this.httpClient.prepareUserAccessHeader(this.token)
        )

        const fundUnionTransactions = this.httpClient.get(
            `fund-presentation/unions/funds/${this.fundId}/transactions`,
            this.httpClient.prepareUserAccessHeader(this.token),
            {
                page: 0,
                size: pageSize
            }
        )

        const requests = [fundUnionInfo, fundUnionTransactions]

        return new Promise((resolve, reject) => {
            axios.all(requests)
                .then(axios.spread((fundUnionInfoResponse, fundTransactionResponse) => {
                    resolve({
                        info: fundUnionInfoResponse,
                        transaction: fundTransactionResponse
                    })
                })).catch(reject)
        })
    }

    getFundTransactions(page, size, startDateValue, endDateValue) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/unions/funds/${this.fundId}/transactions`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page,
                    size,
                    "start-date": startDateValue.length === 10 ? convertPersianDateToUniversalDate(startDateValue) : "",
                    "end-date": endDateValue.length === 10 ? convertPersianDateToUniversalDate(endDateValue) : "",
                }
            ).then(resolve).catch(reject)
        })
    }

}